import { GetTimeSeriesViewRequest, TimeSeriesViewResponse } from 'generated/leaderboard-client';

import { leaderboardClient } from '@neptune/shared/core-apis-leaderboard-domain';

export function fetchTableWidgetSeries(
  request: GetTimeSeriesViewRequest,
): Promise<TimeSeriesViewResponse> {
  return leaderboardClient.getTimeSeriesView(request);
}
